import { APIResponse } from "@/types/api";
import http from "@/composables/api";
import { UnitDataPayload, UnitDataResponse } from "@/types/interface/unit";

async function createUnit(payload: UnitDataPayload) {
  return await http.post<APIResponse<UnitDataResponse>>("unit-type/create", payload);
}

async function updateUnit(idUnit = '', payload: UnitDataPayload) {
  return await http.patch<APIResponse<UnitDataResponse>>(`unit-type/update?id=${idUnit}`, payload);
}

async function getUnit(page = 1, limit = 10, queryParam = "") {
  let pagination = true;
  if (page == 0){
    pagination = false;
  }
  return await http.get<APIResponse<UnitDataResponse>>(`unit-type?is_pagination=${pagination}&page=${page}&limit=${limit}${queryParam}`);
}

async function findUnit(idUnit = "") {
  return await http.get<APIResponse<UnitDataResponse>>(`unit-type/detail?id=${idUnit}`);
}

async function deleteUnit(idUnit = "") {
  return await http.delete<APIResponse<UnitDataResponse>>(`unit-type/delete?id=${idUnit}`);
}

export default {
  createUnit,
  updateUnit,
  getUnit,
  findUnit,
  deleteUnit
};